export default "__VITE_ASSET__EohUoIFN__"